export const mathMod = (n, mod) => (mod + (n % mod)) % mod
